var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":'Sepet Kategorileri',"items":_vm.breadcrumbArray}}),_c('v-app',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('Results')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }